// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorConfiguration = (client) => ({
    /**
     * `GET /vendor/configuration`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListRules
     * @source packages/modules/b2c-core/src/api/vendor/configuration/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/configuration", { method: "GET", query, headers }),
});
//# sourceMappingURL=configuration.js.map